import ThingsToNote from '../views/Stamp/ThingsToNote.vue';
import Tutorial from '../views/Stamp/Tutorial.vue';
import ChooseToStart from '../views/Stamp/ChooseToStart.vue';
import ScanBody from '../views/Stamp/ScanBody.vue';
import ShowResult from '../views/Stamp/ShowResult.vue';
import End from '../views/Stamp/End.vue';

const stampRoutes = [
  {
    path: '/stamp/things_to_note',
    name: 'StampThingsToNote',
    component: ThingsToNote,
  },
  {
    path: '/stamp/tutorial',
    name: 'StampTutorial',
    component: Tutorial,
  },
  {
    path: '/stamp/choose_to_start',
    name: 'StampChooseToStart',
    component: ChooseToStart,
    props: true,
  },
  {
    path: '/stamp/scan_body',
    name: 'StampScanBody',
    component: ScanBody,
    props: true,
  },
  {
    path: '/stamp/show_result',
    name: 'StampShowResult',
    component: ShowResult,
  },
  {
    path: '/stamp/end',
    name: 'StampEnd',
    component: End,
  },
];

export default stampRoutes;
